import { render, staticRenderFns } from "./AddCustomer.vue?vue&type=template&id=22a49601"
import script from "./AddCustomer.vue?vue&type=script&lang=ts"
export * from "./AddCustomer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports